
import Vue from "vue";
export default Vue.extend({
	props: {
		tabs: Array as () => string[],
		value: Number,
		disabled: Boolean
	},
	methods: {
		tabClicked(i:number) {
			this.$emit("input", i);
		}
	}
});
